export default __webpack_public_path__ + "static/6-confirm-request-240373827b4a2a50f8ee1d2451f102b6.png";